export class ConfigDB {
  static data = {
    settings: {
      layout_type: "ltr",
      layout_class: "compact-wrapper",
      sidebar: {
        type: "compact-wrapper",
        iconType: "stroke-svg",
      },
      sidebar_setting: "default-sidebar",
    },
    color: {
      primary_color: "#7366ff",
      secondary_color: "#f73164",
      mix_background_layout: "light-only",
    },
  };
}
export default ConfigDB;
